import { defineMessages } from 'react-intl';

export const contactMessages = defineMessages({
  buttonSendMessage: {
    defaultMessage: 'Send message',
    description: 'Send message button label',
    id: 'contact.button.submit.label',
  },
  emailTextField: {
    defaultMessage: 'Email',
    description: 'Email text field label',
    id: 'contact.input.label.email',
  },
  fullNameTextField: {
    defaultMessage: 'Full Name',
    description: 'Full Name text field label',
    id: 'contact.input.label.textfield',
  },
  headingContact: {
    defaultMessage: 'Contact',
    description: 'Heading for the Contact section',
    id: 'contact.heading',
  },
  headingSuccess: {
    defaultMessage: 'Thank You!',
    description: 'Heading for a successful message sending',
    id: 'contact.success.heading',
  },
  messageDeliveryError: {
    defaultMessage: "Your message couldn't be delivered. Please try again later.",
    description: 'Error message for message delivery failure',
    id: 'contact.error.messageDelivery',
  },
  sendAnotherMessageButton: {
    defaultMessage: 'Send Another Message',
    description: 'Text for the button to send another message',
    id: 'contact.success.sendAnotherMessage',
  },
  subheadingContact: {
    defaultMessage: 'Send message to us',
    description: 'Subheading for the Contact section',
    id: 'contact.subheading',
  },
  subjectTextField: {
    defaultMessage: 'Subject',
    description: 'Subject text field label',
    id: 'contact.input.label.subject',
  },
  successMessage: {
    defaultMessage: 'Your message was sent successfully!',
    description: 'Success message after message sending',
    id: 'contact.success.message',
  },
  yourMessageTextFieldLabel: {
    defaultMessage: 'Message',
    description: 'Your Message text field label',
    id: 'contact.input.label.message',
  },
  yourMessageTextFieldPlaceholder: {
    defaultMessage: 'Your Message',
    description: 'Your Message text field placeholder',
    id: 'contact.input.placeholer',
  },
} as const);
